/* Import Modules */
import $ from "jquery";
import axios, { AxiosRequestConfig } from "axios";
import { usersForMultiPulldownByVue } from "../../variables";

/* Define Script */
const getAxiosOptions = () => {
  const axiosOptions: AxiosRequestConfig = {
    url: "/api/grouping_department_user_by_multi_pulldown",
    method: "GET",
  };

  return axiosOptions;
};

export const getGroupingDepartmentUserByMulti = async () => {
  let usersArray: Array<any> = [];
  const axiosOptions = await getAxiosOptions();
  await axios(axiosOptions)
    .then(async (result) => {
      await $.each(result.data, async function (index: any, value: any) {
        let tempObject = {
          label: value.label,
          options: value.options,
        };
        usersArray.push(tempObject);
      });
      usersForMultiPulldownByVue.users.push(usersArray);
    })
    .catch((error) => {
      console.log(error);
    });
};
